import { useSearchResults } from '../hooks'

import SearchResultChoiceList from './SearchResultChoiceList'

const SearchResults = ({ mapId }) => {
  const [{ visible, resultGroups }, { hide }] = useSearchResults(mapId)

  if (!visible) return null
  return (
    <div className="map--search-result-choices">
      <div className="search--heading">
        <h3>Search Results</h3>
        <img src="images/x-icon.svg" alt="x-icon" onClick={hide} />
      </div>
      <div className="search--choices-wrapper">
        {resultGroups.map((group) => <SearchResultChoiceList key={group.id} mapId={mapId} group={group} />)}
      </div>
    </div>
  )
}

export default SearchResults